const data = {
  pageName: "ChangeBillingAddress",
  services: {
    translations: {
      url: "ChangeBillingAddress/translations",
      params: {}
    },
    userServices: {
      url: "ChangeBillingAddress/userServices",
      params: {}
    },
    settings: {
      url: "ChangeBillingAddress/settings",
      params: {}
    },
    saveSettings: {
      url: "ChangeBillingAddress/saveSettings",
      params: {}
    },
    getGeographicAddress: {
      url: "geographicAddress",
      params: {}
    },
    assetInfo: {
      url: "ChangeBillingAddress/assetInfo",
      params: {}
    }
  },
  locale: "el_GR"
};
exports.data = data;
